import { AuthScheme } from '../../../common/enums';

/**
 * Gets authorization header bearer value
 * @param token JWT to get bearer value with
 * @returns Authorization header bearer value.
 */
export const getAuthBearerValue = (token: string): string => {
  return `${AuthScheme.Bearer} ${token}`;
};
